import WideoObject from './WideoObject';

import { Class } from './model/WideoDef';

import AudioComponent from './components/AudioComponent';
import ScriptComponent from './components/ScriptComponent';

import IMediaObject from './IMediaObject';

export default class AudioObject extends WideoObject implements IMediaObject {

  public fadeOut(currentTime: number): void {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      audioComponent.fadeOut(currentTime);
    }
    return null;    
  }
  
  public getUrl(): string {
    return this.getSrc();
  }

  public getSrc(): string {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      return audioComponent.getSrc();
    }
    return null;
  }
  
  public getDuration(): number {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      return audioComponent.getDuration();
    }
    return null;
  }

  public getSoundDurationAsMs(): number {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      return audioComponent.getSoundDurationAsMs();
    }
    return null;
  }
  public setRepeat(repeat: boolean): void {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      audioComponent.setRepeat(repeat);
    }
  }

  public isRepeat(): boolean {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      return audioComponent.isRepeat();
    }
    return null;
  }

  public isFadeOut(): boolean {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      return audioComponent.isFadeOut();
    }
    return null;
  }

  public setFadeOut(fadeOut: boolean) {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      audioComponent.setFadeOut(fadeOut);
    }
  }

  public getVolume(): number {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      return audioComponent.getVolume();
    }
    return null;
  }


  public setVolume(volume: number) {
    const audioComponent = this.getComponentByClass(Class.AudioComponent) as AudioComponent;
    if (audioComponent) {
      audioComponent.setVolume(volume);
    }
  }

  public static isAudioObject = (object: WideoObject): object is AudioObject => {
    return (object && object.getClass() === Class.AudioObject)
  }


  private getScriptComponent(): ScriptComponent | null {
    const sc = this.getComponentByClass(Class.ScriptComponent);
    return sc ? (sc as ScriptComponent) : null;
  }

  public getScript(): string {
    const sc = this.getScriptComponent();
    return sc ? sc.getScript() || '' : '';
  }

  public setScript(script: string): void {
    const sc = this.getScriptComponent();
    if (sc) sc.setScript(script);
  }

  public getReplicaId(): string | null {
    const sc = this.getScriptComponent();
    return sc ? sc.getReplicaId() : null;
  }

  public setReplicaId(replicaId: string): void {
    const sc = this.getScriptComponent();
    if (sc) sc.setReplicaId(replicaId);
  }  

  public static isScriptAudio(audioObject: WideoObject): boolean {
    if (!AudioObject.isAudioObject(audioObject)) {
      return false;
    }

    return audioObject.getComponentByClass(Class.ScriptComponent) !== null;
  }
}